<template>
  <div
    class="h-full"
    v-loading="tableLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <!-- <div class="icon-search__input mt-10px">
      <el-input
        placeholder="请输入文本"
        v-model="keyword"
        size="small"
        clearable
        @keypress.enter.native="getList"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="getList"></i>
      </el-input>
    </div> -->
    <div class="h-[calc(100%-10px)] overflow-y-auto text-[#fff] mt-10px">
      <div class="mt-50px text-center" v-if="tableData.length === 0">暂无数据~</div>
      <div v-for="(item, index) in tableData" :key="index" class="mb-10px p-12px rounded-md border-1px border-[#0e7a84] cursor-pointer" @click="handleClick(item)">
        <div class="flex justify-between  text-16px font-bold mb-10px">
          <div class="w-160px">{{ item.device }}</div>
          <div class="">{{ item.group }}</div>
          <div class="">{{ item.classname }}</div>
        </div>
        <div class="flex items-center text-14px mb-10px">
          <div class="">{{ item.starttime }}</div>
          <div class="ml-2px mr-2px"> - </div>
          <div class="">{{ item.endtime }}</div>
        </div>
        <div class="flex items-center text-14px text-[#3cd5ce]">
          <div class="">{{ item.workcontent }}</div>
        </div>
      </div>
    </div>

    <twoTicketDialog
      v-if="twoTicketDialogShow"
      ref="twoTicketDialog"
      @close="twoTicketDialogShow = false"
      :detailInfo="detailInfo"
    />
  </div>
</template>

<script>
import axios from 'axios'
import twoTicketDialog from './twoTicketDialog'

export default {
  name: 'FuxianTwoTicket',
  components: {
    twoTicketDialog,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      tableData: [
        // {
        //   device: '1号斗轮机尾车护皮看到你付款的烦恼',
        //   classname: '输煤',
        //   group: '炉燃检修班',
        //   gzpdh: '20230801001',
        //   gzptype: '1号斗轮机尾车护皮',
        //   gzpleader: '张三',
        //   perscode: '123456789012345678',
        //   phone: '13800000000',
        //   workerlist: '张三,李四,王五',
        //   workcontent: '1. 检查1号斗轮机尾车护皮是否正常。2. 检查1号斗轮机尾车护皮是否正常。3. 检查1号斗轮机尾车护皮是否正常。',
        //   workaddress: '火电厂1号斗轮机尾车护皮检修区',
        //   starttime: '2023-08-01 08:00:00',
        //   endtime: '2023-08-01 12:00:00',
        //   gzpstep: '执行中'
        // },
      ],
      tableLoading: false,
      twoTicketDialogShow: false,
      detailInfo: {},
    }
  },
  computed: {
    baseUrl() {
      return Wiz.globalSettings.globalConfig.twoTicketServer
    }
  },
  methods: {
    handleClick(item) {
      this.twoTicketDialogShow = true
      this.detailInfo = item || {}
    },
    async getList() {
      this.tableLoading = true
      axios.get(`${this.baseUrl}/api/czp/LoadAllowTickets?perscode=`).then((res) => {
        console.log(res, '获取两票数据')
        if (!res.data?.error) {
          this.tableData = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error('获取两票数据失败')
        }
      })
      this.tableLoading = false
    },
  },
  async created() {
    this.getList()
  },
}
</script>
